/* eslint-disable class-methods-use-this */
import React from 'react'
import { Thenable } from '@lacele/utils'
import fetchJSON from '../fetchJSON'
import { fetchForce, fetchPending } from './actions'
import { FETCH_GET } from './utils'
import {
    REASON_MOUNTED,
    REASON_URL,
    REASON_METHOD,
    REASON_BODY,
    REASON_REENABLED,
    REASON_DATA_RESET,
    REASON_XAUTHTOKEN
} from './types'

export class FetchComponent extends React.Component {

    componentDidMount() {
        const {
            fetchService,
            canFetch,
            disable,
            disableInitialFetch
        } = this.props
        if (canFetch) {
            this.enqueueFetchOnStore()
        } else if (!disable && !disableInitialFetch) {
            fetchService.dispatchAction(this.props, fetchForce({
                reason: REASON_MOUNTED
            }))
        }
    }

    componentDidUpdate(prevProps) {
        const {
            canFetch,
            disable
        } = this.props
        if (canFetch) {
            this.enqueueFetchOnStore()
        } else if (!disable) {
            // If URL or any relevant prop has changed, then force a new fetch.
            const {
                fetchService,
                url,
                method,
                body,
                xAuthToken
            } = this.props
            let reason
            if (prevProps.url !== url) {
                reason = REASON_URL
            } else if (prevProps.method !== method) {
                reason = REASON_METHOD
            } else if (prevProps.body !== body) {
                reason = REASON_BODY
            } else if (this.shouldFetchAfterReEnable(prevProps, this.props)) {
                reason = REASON_REENABLED
            } else if (this.shouldFetchAfterDataReset(prevProps, this.props)) {
                reason = REASON_DATA_RESET
            } else if (prevProps.xAuthToken !== xAuthToken) {
                reason = REASON_XAUTHTOKEN
            }
            if (reason) {
                fetchService.dispatchAction(this.props, fetchForce({
                    reason
                }))
            }
        }
    }

    shouldFetchAfterReEnable(prevProps, props) {
        return prevProps.disable !== props.disable
            && !props.disable
            && !props.disableInitialFetch
    }

    shouldFetchAfterDataReset(prevProps, props) {
        return prevProps.data !== props.data
            && !props.data
            && props.enableFetchAfterDataReset
            && props.method === FETCH_GET
    }

    enqueueFetchOnStore() {
        const props = { ...this.props }
        const newFetch = Thenable.resolve(this.currentFetch)
            .then(() => this.fetchOnStore(props))
            .then(() => {
                if (this.currentFetch === newFetch) {
                    this.currentFetch = null
                }
            })
        this.currentFetch = newFetch
        return newFetch
    }

    fetchOnStore(props) {
        const {
            fetchService,
            url,
            onData
        } = props
        fetchService.dispatchAction(props, fetchPending())
        const options = fetchService.makeOptions(props)
        return fetchJSON(url, options)
            .then(fetchService.onSuccessHandler.bind(fetchService, props))
            .then((data) => (onData ? onData(data, props) : data))
            .catch(fetchService.onErrorHandler.bind(fetchService, props))
    }

    render() {
        const {
            children
        } = this.props
        return children ? React.Children.only(children) : null
    }
}
